if (!window.FitFinderManager || !window.SizeChartManager) {

const SizeChartManager = () => {

  let config;

  const inject = () => {
    const { displaySelectorId, sizeChartUrl, sizeChartHtmlUrl, diagramUrl } = config;
    if (!window.FitFinder) return;

    const target = document.getElementById(displaySelectorId);
    const props = {
      stylecode,
    } = config;


    window.FitFinder.push(['configure', {
      sizeChartUrl,
      sizeChartHtmlUrl,
      diagramUrl
    }])
    if (typeof window.FitFinder.mountSizeChart === 'function') {
      window.FitFinder.mountSizeChart(target, props);
    } else {
      window.FitFinder.push(['mountSizeChart', target, props]);
    }
  }

  const init = (options) => {
    config = options;

    inject()
  }

  return { init }
}

const FitFinderManager = () => {

  const STORAGE_KEY = 'fitFinderRecommendations';
  let config;

  const inject = () => {
    const { displaySelectorId, stylecode, sizeChartUrl, sizeChartHtmlUrl, diagramUrl } = config;
    if (!window.FitFinder) return;

    const target = document.getElementById(displaySelectorId);
    const props = {
      stylecode,
      onRecommendation: (e) => storeAndApply(e),
      onClose: () => {
        const slideIn = target.closest('.slide-in-info');
        if (slideIn) slideIn.hide()

      }
    };
    window.FitFinder.push(['configure', {
      sizeChartUrl,
      sizeChartHtmlUrl,
      diagramUrl
    }])
    if (typeof window.FitFinder.mountSizeInput === 'function') {
      window.FitFinder.mountSizeInput(target, props);
    } else {
      window.FitFinder.push(['mountSizeInput', target, props]);
    }
  }

  const storeAndApply = ({ stylecode, recommendedSize }) => {

    storeRecommendedSize({ stylecode, recommendedSize })

    const optionElement = getOptionElement()
    if (!optionElement) return;
    selectRecommendedSize(optionElement, recommendedSize)
  }

  const storeRecommendedSize = ({ stylecode, recommendedSize }) => {
    const existing = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    const index = existing.findIndex(entry => entry.stylecode === stylecode);
    if (index !== -1) {
      existing[index].recommendedSize = recommendedSize;
    } else {
      existing.push({ stylecode, recommendedSize });
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
  }

  const getStoredRecommendedSize = (stylecode) => {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return stored.find(entry => entry.stylecode === stylecode)?.recommendedSize ?? null;
  }

  const selectRecommendedSize = (select, recommendedSize) => {
    const option = [...select.options].find(
      option => option.dataset.value === String(recommendedSize) || option.value === String(recommendedSize)
    );
    if (!option) return false;
    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  };

  const init = (options) => {
    config = options;

    inject()

    const { enableRecommendedSizeSelection } = config;
    if (enableRecommendedSizeSelection)
      handleStoredRecommendedSize()
  }

  const getOptionElement = () => {
    const { optionSelector } = config;
    const optionElement = document.querySelector(optionSelector);
    return optionElement || null;
  }

  const handleStoredRecommendedSize = () => {

    const { stylecode } = config;

    const previousRecommendedSize = getStoredRecommendedSize(stylecode);
    if (previousRecommendedSize) {
      setTimeout(() => {
        const optionElement = getOptionElement()
        if (!optionElement) return;
        selectRecommendedSize(optionElement, previousRecommendedSize)
      })
    }
  }

  return { init, getStoredRecommendedSize }
}

window.FitFinderManager = window.FitFinderManager || FitFinderManager;
window.SizeChartManager = window.SizeChartManager || SizeChartManager;

}
